import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Constants } from 'src/app/modules/shared/models/constants';
import { T } from 'src/assets/i18n/translation-keys';

@Component({
    selector: 'app-traffic-layer-button',
    templateUrl: './traffic-layer-button.component.html',
    styleUrls: ['./traffic-layer-button.component.scss'],
    standalone: false
})
export class TrafficLayerButtonComponent implements OnInit {
  @Input() showLabel = false;
  @Input() map: google.maps.Map = null;

  public readonly T = T;
  public isMobile = false;

  private trafficLayer: google.maps.TrafficLayer = null;

  constructor(
    private ref: ChangeDetectorRef,
    private readonly translateService: TranslateService,
  ) {}

  ngOnInit(): void {
    this.isMobile = window.innerWidth < Constants.xs;

    this.trafficLayer = new google.maps.TrafficLayer();
    this.trafficLayer.setMap(null);
  }

  get trafficLayerActive(): boolean {
    return this.trafficLayer.getMap() != null;
  }

  get btnTitle(): string {
    return this.trafficLayer.getMap()
      ? this.translateService.instant(T.settings.location_manager.hide_traffic_layer)
      : this.translateService.instant(T.settings.location_manager.show_traffic_layer);
  }

  onClick() {
    if (this.trafficLayer.getMap() === null) {
      this.trafficLayer.setMap(this.map);
    } else {
      this.trafficLayer.setMap(null);
    }
  }

}
